
import { Component, Prop, Vue } from 'vue-property-decorator';
import LoyaltyCertUpdateForm from '@/form/loyalty/loyaltyCert/LoyaltyCertUpdateForm';
import FormGroup from '@/UI/components/common/form/FormGroup.vue';
@Component({
    components: { FormGroup }
})
export default class LoyaltyCertUpdateFormComponent extends Vue {
    @Prop() form!: LoyaltyCertUpdateForm;
}
